export enum PermissionTypes {
  User = "tenant.user",
  Manager = "tenant.manager",
  SystemIntegrator = "tenant.system-integrator",
  Operator = "tenant.operator",
  Admin = "tenant.admin",
}
